import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';
import {
  UpdateInformationType,
  User,
} from 'src/app/shared/types/my-account.types';

@Injectable({
  providedIn: 'root',
})
export class MyAccountService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}/account`;
  }

  getUserDetail(): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}`);
  }

  update(body: UpdateInformationType): Observable<{ data: any }> {
    return this.http.put<{ data: any }>(`${this.baseUrl}`, body);
  }
}
